import createSvgIcon from '../Utils/CreateSvgIcon';

export const Trash = createSvgIcon(
  <path d="M7.33334 21.5C6.78334 21.5 6.31251 21.3042 5.92084 20.9125C5.52918 20.5208 5.33334 20.05 5.33334 19.5V6.5H4.33334V4.5H9.33334V3.5H15.3333V4.5H20.3333V6.5H19.3333V19.5C19.3333 20.05 19.1375 20.5208 18.7458 20.9125C18.3542 21.3042 17.8833 21.5 17.3333 21.5H7.33334ZM17.3333 6.5H7.33334V19.5H17.3333V6.5ZM9.33334 17.5H11.3333V8.5H9.33334V17.5ZM13.3333 17.5H15.3333V8.5H13.3333V17.5Z" />,
  'Trash',
);
